// Guest cart persistence (localStorage). Registered users' carts live on the
// server; guests keep theirs here until they log in (then it's merged).
//
// Stored shape: [{ productId, title, unitPrice, quantity, photoUrl }]
// (title/unitPrice/photoUrl are snapshotted at add-time so the guest cart can
// render without hitting the auth-only /api/cart endpoint.)

const CART_KEY = 'ss-v2-cart';

export function readGuestCart() {
  try {
    const raw = window.localStorage.getItem(CART_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function writeGuestCart(items) {
  try {
    window.localStorage.setItem(CART_KEY, JSON.stringify(items || []));
  } catch {
    /* storage unavailable — non-fatal */
  }
}

export function clearGuestCart() {
  try {
    window.localStorage.removeItem(CART_KEY);
  } catch {
    /* non-fatal */
  }
}
